// extracted by mini-css-extract-plugin
export default {"addToCartControl":"CY-z","giftCard":"DY-z","btnContainer":"EY-z","cartButton":"FY-z","disabled":"GY-z"};